import Table, { TableColumnConfiguration } from './table/Table'
import { UserMetalAccountDTO } from '@ringo/shared'
import { useQueryWithLoader } from '../loader/useQueryWithLoader'
import { TranslationFunc, useTranslation } from '../../useTranslation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMetalAccountaApi } from '../../common/api-context'
import { useFormatting } from '../../common/hooks/useFormatting'

type MetalType = {
    metalName: string
    quantity: number
    unit: string
}

const MetalAccountBalance = () => {
    const { t } = useTranslation()
    const metalAccountApi = useMetalAccountaApi()
    const { formatNumber } = useFormatting()

    const { data: metalData } = useQueryWithLoader('getMetalAccount', ['getMetalAccount'], async () => {
        return (await metalAccountApi.getMetalAccount()).data
    })

    const columnConfiguration: Array<TableColumnConfiguration<MetalType>> = [
        {
            id: 'metalName',
            title: t('yourBasket.preciousMetal'),
            shouldSort: false,
            style: {
                textAlign: 'left',
                width: '33%',
            },
        },
        {
            id: 'quantity',
            title: t('quantity'),
            shouldSort: false,
            customRender: (quantity) => {
                const value = quantity.getValue()
                let className = ''

                if (value < 0) {
                    className = 'text-green-400'
                } else if (value > 0) {
                    className = 'text-red-400'
                } else {
                    className = 'text-black'
                }

                return <span className={className}>{formatNumber(value)}</span>
            },
            style: {
                textAlign: 'right',
                width: '33%',
            },
        },
        {
            id: 'unit',
            title: t('unit'),
            shouldSort: false,
            style: {
                textAlign: 'right',
                width: '33%',
            },
        },
    ]

    return (
        <div>
            <div>{metalData && <Table columnConfiguration={columnConfiguration} tableData={metalData ? prepareDataForTable(metalData, t) : []} />}</div>
            <div className="flex  mt-6">
                <FontAwesomeIcon icon={['fas', 'circle-info']} className="text-custom_blue text-sm pr-2 align-middle mt-[3px]" />
                <p className="text-base text-black font-light text-left max-tablet:text-sm">
                    {t('yourBasket.currentOrdersAndSeparationsThatHaveNotYetBeenInvoicedAreNotIncluded')}
                </p>
            </div>
            <div className="flex  mt-2">
                <FontAwesomeIcon icon={['fas', 'circle-info']} className="text-custom_blue text-sm pr-2 align-middle mt-[3px]" />
                <p className="text-base text-black font-light text-left max-tablet:text-sm">{t('yourBasket.negativeValuesYourBallance')}</p>
            </div>
        </div>
    )
}

function prepareDataForTable(metalData: UserMetalAccountDTO, t: TranslationFunc): MetalType[] {
    const tableData = [
        {
            metalName: `${t('yourBasket.gold')} (Au)`,
            quantity: metalData.auUnit,
            unit: t('gram'),
        },
        {
            metalName: `${t('yourBasket.silver')} (Ag)`,
            quantity: metalData.agUnit,
            unit: t('gram'),
        },
        {
            metalName: `${t('yourBasket.platinum')} (Pt)`,
            quantity: metalData.ptUnit,
            unit: t('gram'),
        },
        {
            metalName: `${t('palladium')} (Pd)`,
            quantity: metalData.pdUnit,
            unit: t('gram'),
        },
    ]

    return tableData as MetalType[]
}

export default MetalAccountBalance
